'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'

const CreateReelContestBanner: FC = () => {
  const { t } = useI18n()

  return (
    <div
      className="relative flex h-full w-full flex-col items-center justify-between bg-cover bg-center px-4 pb-[48px] pt-[110px]"
      style={{
        backgroundImage: 'url(/activity/reelcontestbanner-webmobile.png)',
      }}
    >
      {/* 下方内容区域 */}
      <div className=" flex h-full w-full flex-col items-center gap-3">
        {/* 主标题区 */}
        <div className="flex flex-col items-center justify-center px-2 text-center">
          <p className="mb-2 text-center text-[13px] font-normal leading-[17px] text-white/70">
            {t('Create and Publish your reels to win')}
          </p>
          <div className="text-center text-[13px] font-normal text-white">
            {t('Deluxe membership!')}
          </div>
        </div>

        {/* 时间信息 */}
        <div className="flex flex-col items-center justify-center  text-center">
          <p className="p-1 text-center text-[13px] font-normal leading-[1.33em] text-white/80">
            {/* i18n-ignore */ '11/10-11/23'}
          </p>
        </div>

        {/* 查看按钮 */}
        <div className="flex w-full flex-1 flex-col">
          <button className="mt-auto h-[26px] w-auto rounded-full bg-white/20 px-8 text-[13px] font-medium leading-[26px] text-white hover:bg-white/30">
            {t('View')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreateReelContestBanner
